// Payment method form functionality
// Extracted from mercury_provider/payment_method.html.slim inline script

document.addEventListener('DOMContentLoaded', () => {
  // Broker checkbox handling
  const brokerCheckboxes = document.querySelectorAll('.broker-checkbox input[type="checkbox"]')
  const selectAllCheckbox = document.getElementById('select-all-brokers')
  const brokerTotalCount = document.getElementById('broker-total-count')
  const totalBrokerAmount = document.getElementById('total-broker-amount')

  if (brokerCheckboxes.length > 0) {
    // Get broker amount from data attribute or calculate from first visible amount
    let brokerAmount = 0
    const firstAmountElement = document.querySelector('.broker-amount')
    if (firstAmountElement && firstAmountElement.textContent) {
      const match = firstAmountElement.textContent.match(/\$(\d+(?:,\d{3})*)/)
      if (match) {
        brokerAmount = parseInt(match[1].replace(/,/g, ''))
      }
    }

    // Check if there's a mandatory broker (loan writer's own account)
    const mandatoryBrokerRow = document.querySelector('.broker-row-mandatory')
    const mandatoryBrokerCount = mandatoryBrokerRow ? 1 : 0

    const recalculateBrokerTotal = () => {
      const selectedCheckboxes = Array.from(brokerCheckboxes).filter(cb => cb.checked)
      const brokerCount = selectedCheckboxes.length
      const totalCount = mandatoryBrokerCount + brokerCount
      const total = totalCount * brokerAmount

      if (brokerTotalCount) {
        brokerTotalCount.textContent = totalCount.toLocaleString()
      }
      if (totalBrokerAmount) {
        totalBrokerAmount.textContent = `$${total.toLocaleString()} / month`
      }
    }

    const updateSelectAllState = () => {
      if (selectAllCheckbox) {
        const selectedCount = Array.from(brokerCheckboxes).filter(cb => cb.checked).length
        const totalCheckboxes = brokerCheckboxes.length
        selectAllCheckbox.checked = selectedCount === totalCheckboxes
      }
    }

    const updateBrokerSelection = (checkbox, checked) => {
      checkbox.checked = checked
      const brokerId = checkbox.value
      const amountElement = document.getElementById(`broker-amount-${brokerId}`)

      if (amountElement) {
        if (checked) {
          amountElement.textContent = `$${brokerAmount.toLocaleString()} / month`
        } else {
          amountElement.innerHTML = '&nbsp;'
        }
      }

      updateSelectAllState()
      recalculateBrokerTotal()
    }

    // Individual broker checkbox change handler
    brokerCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        updateBrokerSelection(e.target, e.target.checked)
      })
    })

    // Select all checkbox handler
    if (selectAllCheckbox) {
      selectAllCheckbox.addEventListener('change', (e) => {
        brokerCheckboxes.forEach(checkbox => {
          updateBrokerSelection(checkbox, e.target.checked)
        })
      })
    }

    // Initialize on page load
    recalculateBrokerTotal()
    updateSelectAllState()
  }

  // Credit card form submit handling
  const creditCardForm = document.getElementById('new_credit_card')
  const creatingAccountMessage = document.getElementById('creating-account-message')
  const userHeader = document.getElementById('user-header')
  const planDetailsPanel = document.getElementById('plan-details-panel')
  const creditCardPanel = document.getElementById('credit-card-panel')

  if (creditCardForm) {
    let completingRegistration = false

    creditCardForm.addEventListener('submit', (e) => {
      if (!completingRegistration) {
        completingRegistration = true

        if (creatingAccountMessage) {
          creatingAccountMessage.style.display = 'block'
        }
        if (userHeader) {
          userHeader.style.display = 'none'
        }
        if (planDetailsPanel) {
          planDetailsPanel.style.display = 'none'
        }
        if (creditCardPanel) {
          creditCardPanel.style.display = 'none'
        }

        return true
      } else {
        e.preventDefault()
        return false
      }
    })
  }
})
